"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNetLoader = void 0;
const scriptLibraryLoader_1 = require("../../../core/library/loader/scriptLibraryLoader");
const constants_1 = require("./constants");
class GetNetLoader extends scriptLibraryLoader_1.ScriptLibraryLoader {
    constructor(getNetUrl) {
        super('GetNet', constants_1.LOAD_CONFIG);
        this.getNetUrl = getNetUrl;
    }
    getUrls() {
        return [this.getNetUrl];
    }
}
exports.GetNetLoader = GetNetLoader;
//# sourceMappingURL=index.js.map